import { DocumentsFiling } from "./DocumentsFiling";
import { Task } from "./Task";

export class TaskDoneDetails {
    Task: Task;
    TaskEntity: any;
    Documents?: any[];
}